import {
  PreloadedState,
  Reducer,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import apiSlice from 'renderer/shared/state/apiSlice';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import userReducer from '../../features/auth/state/userSlice';
import transactionReducer from '../../features/payments-page/state/transactions.slice';
import usersTableReducer from '../../features/users-page/state/usersTable.slice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
  // whitelist: ['user', 'auth'],
};

const rootReducer = combineReducers({
  transaction: transactionReducer,
  user: userReducer,
  usersTable: usersTableReducer,
  // auth: authReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const appReducer: Reducer = (state, action) => {
  if (action.type === 'RESET') {
    storage.removeItem('persist:root');
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export const createStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    // reducer: appReducer,
    reducer: persistedReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(apiSlice.middleware),
  });
};

export const store = createStore();
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
